import React, { useState, useEffect, useRef } from 'react'
import styles from './styles.module.scss'

import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import SignatureCanvas from 'react-signature-canvas'
import { IsMobile } from '../../layout'
import axios from 'axios'
import { SubmitButton, SubmitButtonMail } from '..'
import { useParams } from 'react-router-dom'
import { log } from 'console'
import ReactPixel from 'react-facebook-pixel'
import { trackSubmitApplication } from '../../../helpers/handleTracking'

interface sigProps {
    additionalAction?: () => void | null
    extraPayload?: any
    disclaimer?: any
    isDisabled?: boolean
    onSignatureChange?: (hasSignature: boolean) => void
}

export const SignaturePad = ({
    extraPayload,
    additionalAction,
    disclaimer,
    isDisabled = false,
    onSignatureChange,
}: sigProps) => {
    const signCanvas = React.useRef(null) as React.MutableRefObject<any>
    const [sigData, setSigData] = useState('')
    const [canvasWidth, setCanvasWidth] = useState(0)
    const containerRef = useRef<HTMLDivElement>(null)

    const { token } = useParams()

    useEffect(() => {
        const updateCanvasWidth = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.clientWidth
                setCanvasWidth(containerWidth)

                if (signCanvas.current) {
                    signCanvas.current.clear()
                    signCanvas.current.on()
                }
            }
        }

        updateCanvasWidth()
        window.addEventListener('resize', updateCanvasWidth)

        return () => {
            window.removeEventListener('resize', updateCanvasWidth)
        }
    }, [])

    const saveSign = () => {
        signCanvas.current.on()
        let x = signCanvas.current.toDataURL('image/png')
        setSigData(x)
        if (onSignatureChange) {
            onSignatureChange(x.length > 1)
        }
    }

    const clearSign = (e: React.MouseEvent) => {
        e.preventDefault()
        clearSigPad()
    }

    const clearSigPad = () => {
        signCanvas.current.clear()
        signCanvas.current.on()
        setSigData('')
        if (onSignatureChange) {
            onSignatureChange(false)
        }
    }

    const submitSignature = () => {
        if (sigData.length < 1) {
            Report.failure('Please Sign', 'Please enter your signature onto the signature pad to continue.', 'OK')
            return
        }

        Loading.circle('Signing Document')
        let payload = {
            token,
            type: '',
            sigData: sigData,
        }

        if (extraPayload && Object.keys(extraPayload).length) {
            payload = { ...payload, ...extraPayload }
        }

        axios
            .post(`${process.env.REACT_APP_API_SIGN_URL}`, payload)
            .then(function (response) {
                console.log(response)
                Loading.remove()
                if (response.data !== 'SUCCESS') {
                    Report.failure(
                        'An Error Occurred',
                        'We have encounterred an internal error, please try again later. If the problem persists please contact support@sentinellegal.co.uk',
                        'Okay'
                    )
                    return
                }
                if (additionalAction) additionalAction()
                trackSubmitApplication()
            })
            .catch(function (error) {
                console.log(error)
                Loading.remove()
                Report.failure(
                    'An Error Occurred',
                    'We have encounterred an internal error, please try again later. If the problem persists please contact support@sentinellegal.co.uk',
                    'Okay'
                )
            })
    }

    return (
        <div className={styles.signaturePadContent}>
            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Please sign your name in BLOCK CAPITALS</div>
            <div className={`${styles.sigPadContainer}`} ref={containerRef}>
                <p>Please use your mouse, finger or stylus to draw your signature below.</p>
                <div>
                    <SignatureCanvas
                        ref={signCanvas}
                        onEnd={saveSign}
                        clearOnResize={false}
                        penColor="grey"
                        canvasProps={{
                            width: canvasWidth || (window.innerWidth < 760 ? 350 : 760),
                            height: window.innerWidth < 480 ? 200 : window.innerWidth < 768 ? 250 : 300,
                            className: 'sigCanvas',
                        }}
                    />
                    <span onClick={clearSign}>Clear</span>
                </div>
            </div>
            {disclaimer && <p className={styles.signatureDisclaimer}>{disclaimer}</p>}
            <div className={styles.buttonContainer}>
                <SubmitButtonMail
                    text="Submit"
                    btnType="primary"
                    onClick={submitSignature}
                    disabled={isDisabled || sigData.length < 1}
                />
            </div>
        </div>
    )
}
